import {
    FETCH_UPDATE_UNIVERSITY_REQUEST,
    FETCH_UPDATE_UNIVERSITY_SUCCESS,
    FETCH_UPDATE_UNIVERSITY_FAILURE,
    SET_UPDATE_SEARCHER
} from '../../actions/universities/update-universities-actions';

const initialState = {
    updatedUniversity: null,
    searcher: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateUniversityReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_UPDATE_UNIVERSITY_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case SET_UPDATE_SEARCHER:
            return {
                ...state,
                isLoading: false,
                error: null,
                university: { ...action.payload }
            };
        case FETCH_UPDATE_UNIVERSITY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                updatedUniversity: action.payload[0],
            };
        case FETCH_UPDATE_UNIVERSITY_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default UpdateUniversityReducer;